import React from "react";
import "../styles/About.css";
import FadeInSection from "./FadeInSection";

class About extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1",
    };
    this.handleSelect = this.handleSelect.bind(this);
  }

  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey,
    });
  }

  render() {
    const one = (
      <p>
        I am a Network & Cybersecurity Engineering student at{" "}
        <a
          href="https://sut.edu.eg/"
          target="_blank"
          rel="noreferrer noopener"
        >
          Elsewedy University of Technology
        </a>{" "}
        (<b>4.1 / 4.3 GPA</b>, Dean's List) with a strong focus on <b>offensive security</b>, <b>AI security</b>, and <b>vulnerability research</b>.
        <br />
        <br />
        I specialize in dissecting complex systems to uncover critical flaws—from discovering zero-days in the <b>Go standard library</b> (Google OSS VRP) and <b>Apple WebKit</b> to executing advanced penetration tests as an Offensive Security Engineer at{" "}
        <a
          href="https://deepstrike.io/"
          target="_blank"
          rel="noreferrer noopener"
        >
          Deep Strike
        </a>
        . My research has earned Hall of Fame recognition from <b>Google</b>, <b>Apple</b>, and the <b>French Government</b>...
      </p>
    );

    const two = (
      <p>
        Outside of hunting vulnerabilities, I publish deep-dive technical write-ups on <b>Medium</b> and share offensive security tutorials on <b>YouTube</b> to give back to the community.
      </p>
    );

    const tech_stack = [
      "AI Security",
      "Web Security",
      "Network Pentesting",
      "Python",
      "JavaScript"
    ];

    return (
      <div id="about">
        <FadeInSection>
          <div className="section-header ">
            <span className="section-title">/ about me</span>
          </div>

          <div className="about-content">
            <div className="about-description">
              {one}

              {"Here are some technologies I have been working with:"}

              <ul className="tech-stack">
                {tech_stack.map((tech_item, i) => (
                  <FadeInSection key={tech_item + i} delay={`${i + 1}00ms`}>
                    <li>{tech_item}</li>
                  </FadeInSection>
                ))}
              </ul>

              {two}
            </div>

            <div className="about-image"></div>
          </div>
        </FadeInSection>
      </div>
    );
  }
}

export default About;
